module.exports = __webpack_public_path__ + "static/media/26UNRWA15.d3d1b4b1.jpg";